import { ICommonRes } from '../interface/api/common';
import { stmHttpClient } from '@/plugins/HttpManager';
import type { CMKFull, CMKInput, CMKModifyInput, CMKSyncInput } from '@reolink-web/cloud-rs-crypto-bindgen';

export const getCMKById = async ( id: string ): Promise<CMKFull> => {

    return ( await stmHttpClient.get( `/key-vault/cmks/${id}` )).data;

};

export const getCMKS = async (): Promise<ICommonRes<CMKFull>> => {

    return ( await stmHttpClient.get( `/key-vault/cmks` )).data;

};

export const getExtractCMK = async ( id: string, pinHash: string | null ): Promise<CMKFull> => {

    return (
        await stmHttpClient.post( '/key-vault/cmks/extractions', {
            id,
            pinHash
        })
    ).data;

};

export const registerCMK = async ( CMKInput: CMKInput ): Promise<any> => {

    return (
        await stmHttpClient.post( '/key-vault/cmks', {
            content: CMKInput
        })
    ).data;

};

export const modifyCMK = async ( CMKModifyInput: CMKModifyInput | CMKSyncInput, session: { id: string; code: string; }): Promise<any> => {

    return (
        await stmHttpClient.put( '/key-vault/cmks', CMKModifyInput, {
            headers: {
                'x-verify-id': session.id,
                'x-verify-code': session.code
            }

        })
    ).data;

};
